export enum EPoolingRoute {
  POOLING = '/pooling/:identifier',
}
